import React, { Fragment, useState, useCallback, useEffect } from 'react';
import { createBrowserHistory } from "history";
import qs from 'qs';
import { useDispatch, useSelector } from 'react-redux';
import { translate } from '../../Services/translation';
import {
  loadchassisearch,
  clearchassisearch,
} from './../../Actions/ChassiSearch.action';
import GridViewNonPimItemContainer from '../../Components/ChassiSearch/GridViewNonPimItemContainer';
import ListViewNonPimItemContainer from '../../Components/ChassiSearch/ListViewNonPimItemContainer';
import ChassiSearchItemsContainer from './ChassiSearchItemsContainer';
import { keyboardNavigationPress } from '../../Services/Wcag';

const ChassiSearchContainer = () => {
  const dispatch = useDispatch();
  const [searchString, setsearchString] = useState('');
  const [viewStatus, setViewStatus] = useState(1);
  const chassiDataModel = useSelector((state) => state.chassisearch);
  const [inputValue, setInputValue] = useState('');
  const [selectedChassiIndex, setSelectedChassiIndex] = useState(-1);
  const history = createBrowserHistory();

  const {
    chassiSearchList,
    errors,
    pageInitialized,
    isloading,
    isDataerror,
  } = chassiDataModel;

  const onChange = (value) => {
    setInputValue(value);
    setsearchString(value);
    if (value.length == 0) {
      history.push();
    }
  };
  const search = useCallback(
    (searchString) => {
      setSelectedChassiIndex(-1);
      dispatch(loadchassisearch(searchString));
      history.push(
        `?searchstring=${searchString}&selchassiindex=${selectedChassiIndex}&viewstatus=${viewStatus}`
      );
    },
    [dispatch]
  );

  useEffect(() => {
    const locations = history.location.search.substr(1);
    const locParams = qs.parse(locations);
    if (
      locParams &&
      locParams.searchstring &&
      locParams.selchassiindex &&
      locParams.viewstatus
    ) {
      onChange(locParams.searchstring);
      dispatch(loadchassisearch(locParams.searchstring));
      setViewStatus(locParams.viewstatus);
      setSelectedChassiIndex(locParams.selchassiindex);
    }
  }, []);

  const handleClear = () => {
    setInputValue('');
    setsearchString('');
    dispatch(clearchassisearch());
    history.push();
  };

  const viewSelectedChassi = (index) => {
    setSelectedChassiIndex(index);
    history.push(
      `?searchstring=${searchString}&selchassiindex=${index}&viewstatus=${viewStatus}`
    );
  };

  const onClickViewstatus = (value) => {
    setViewStatus(value);
    history.push(
      `?searchstring=${searchString}&selchassiindex=${selectedChassiIndex}&viewstatus=${value}`
    );
  };

  const IsValidData = () => {
    return (
      selectedChassiIndex >= 0 &&
      chassiSearchList &&
      chassiSearchList.length > 0
    );
  };

  const hasYear = (chassiSearchList) => {
    return chassiSearchList.some(e => e.GeneralInfo.Year)
  }

  const hasSpareParts = (chassiSearchList) => {
    let has = false;
    chassiSearchList.forEach(chassi => {
      if(chassi.Categories.some(e => e.CategoryName === 'Spareparts1')) {
        has = true;
      }
    });
    return has;
  }

  const hasAccessories = (chassiSearchList) => {
    let has = false;
    chassiSearchList.forEach(chassi => {
      if(chassi.Categories.some(e => e.CategoryName === 'Accessories')) {
        has = true;
      }
    });
    return has;
  }

  return (
    <Fragment>
      <div className="row">
        <div className="columns small-12 chassi-search--wrapper">
          <div className="chassi-search--banner">
            <div className="row">
              <div className="columns small-12 text--center">
                <h2>{translate('chassisearch.heading')}</h2>
              </div>
            </div>
            <div className="row">
              <div className="columns small-12 medium-8 medium-offset-2 large-6 large-offset-3 text--center">
                <label htmlFor="chassi-input">
                  {translate('chassisearch.registernumberandchassi')}
                </label>
                <div className="chassi-search--banner--inputgroup">
                  <input
                    id="chassi-input"
                    type="text"
                    value={inputValue}
                    placeholder={translate(
                      'chassisearch.registernumberandchassi'
                    )}
                    onChange={(event) => onChange(event.target.value)}
                    onKeyPress={(event) => {
                      if (event.key === 'Enter') {
                        search(searchString);
                      }
                    }}
                  />
                  <a
                    tabIndex={0}
                    className="button"
                    onClick={(event) => search(searchString)}
                    onKeyDown={keyboardNavigationPress(() => search(searchString))}
                  >
                    {translate('general.search')}
                  </a>
                </div>
                <p>{translate('chassisearch.regdescription')}</p>
              </div>
              <div className="columns small-12 text--center">
                <a 
                  tabIndex={0} 
                  className="reset-search" 
                  onClick={handleClear} 
                  onKeyDown={(e) => {
                    if (e.key === 'Enter' || e.key === ' ') {
                      e.preventDefault(); 
                      handleClear();
                    }
                  }}
                >
                  {translate('chassisearch.resetsearch')}
                </a>
              </div>
            </div>
          </div>

          {errors.length > 0 &&
            errors.map((error, index) => {
              return (
                <div className="chassi-search--error" key={'error' + index}>
                  <svg>
                    <use href="/ui/images/sprites/brenderup.svg#error"></use>
                  </svg>
                  {translate(error)}
                </div>
              );
            })}

          {isloading ? (
            <div className="loading--wrapper">
              <div className="loading-circle"></div>
            </div>
          ) : (
            <Fragment>
              {pageInitialized == false && (
                <div>
                  {chassiDataModel &&
                  chassiSearchList &&
                  chassiSearchList.length > 0 ? (
                    <div className="chassi-search--result-table">
                      <div className="tablediv">
                        <table className="trailer-list">
                          <thead>
                            <tr>
                              <th>{translate('chassisearch.chassinumber')}</th>
                              <th>
                                {translate('chassisearch.registernumber')}
                              </th>
                              {hasYear(chassiSearchList)  && <th>
                              {translate('chassisearch.yearofmanufacture')}
                              </th>}
                              <th>{translate('chassisearch.trailermodel')}</th>
                              <td aria-hidden={"true"}></td>
                            </tr>
                          </thead>
                          <tbody>
                            {chassiSearchList.map(({ GeneralInfo }, index) => {
                              return (
                                GeneralInfo &&
                                GeneralInfo.ChassiNumber && (
                                  <tr
                                    key={'chassi-trailer-list-tr' + index}
                                    className={
                                      index == selectedChassiIndex
                                        ? 'chassi-search--active-row'
                                        : 'chassi-search--inactive-row'
                                    }
                                  >
                                    <td>
                                      <a
                                        tabIndex={0}
                                        onClick={() => {
                                          viewSelectedChassi(index);
                                        }}
                                        onKeyDown={keyboardNavigationPress(() => viewSelectedChassi(index))}
                                      >
                                        {GeneralInfo.ChassiNumber}
                                      </a>
                                    </td>
                                    <td>{GeneralInfo.RegNr}</td>
                                    {hasYear(chassiSearchList) && <td>{GeneralInfo.Year}</td>}
                                    <td>{GeneralInfo.TrailerDescription}</td>
                                    <td className="text--right">
                                      <a
                                        tabIndex={0}
                                        className="button chassi-search--view-btn"
                                        onClick={() => {
                                          viewSelectedChassi(index);
                                        }}
                                        onKeyDown={keyboardNavigationPress(() => viewSelectedChassi(index))}
                                      >
                                        {translate('chassisearch.view')}
                                      </a>
                                    </td>
                                  </tr>
                                )
                              );
                            })}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  ) : (
                    errors.length == 0 && (
                      <div className="chassi-search--error">
                        <svg>
                          <use href="/ui/images/sprites/brenderup.svg#error"></use>
                        </svg>
                        {translate('chassisearch.errormessage')}
                      </div>
                    )
                  )}

                  {IsValidData() && (
                    <div className="chassi-search--current-trailor">
                      <div className="row">
                        <div className="columns small-12 text--center">
                          <h3>{translate('chassisearch.selectedtrailor')}</h3>
                        </div>
                        <div className="columns small-12 medium-3 trailor-image">
                          <figure
                            dangerouslySetInnerHTML={{
                              __html:
                                chassiSearchList[selectedChassiIndex].GeneralInfo.Image
                            }}
                          ></figure>
                        </div>
                        <div className="columns small-12 medium-9">
                          <p>
                            {translate('chassisearch.chassinumber')}:&nbsp;
                            {
                              <a href={chassiSearchList[selectedChassiIndex].ChassiUrl}>{chassiSearchList[selectedChassiIndex].GeneralInfo
                              .ChassiNumber}</a> 
                            }
                          </p>
                          {chassiSearchList[selectedChassiIndex].GeneralInfo
                                .Year && 
                          <p>
                            {translate('chassisearch.yearofmanufacture')}:&nbsp;
                            {
                              chassiSearchList[selectedChassiIndex].GeneralInfo
                                .Year
                            }
                          </p>}
                          {chassiSearchList[selectedChassiIndex].GeneralInfo
                                .ChassiArticleNumber && 
                          <p>
                            {translate('chassisearch.trailerarticlenumber')}:&nbsp;
                            {
                              chassiSearchList[selectedChassiIndex].GeneralInfo
                                .ChassiArticleNumber
                            }
                          </p>}
                            <p>
                            {translate('chassisearch.trailermodel')}:&nbsp;
                            {
                              chassiSearchList[selectedChassiIndex].GeneralInfo
                                .TrailerDescription
                            }
                          </p>
                          
                        </div>
                      </div>
                    </div>
                  )}
                  {viewStatus == 0 ? (
                    <Fragment>
                      {IsValidData() && (
                        <Fragment>
                          <div className="chassi-search--switch-view">
                            <a
                              className={
                                viewStatus == 0
                                  ? 'switch grid active'
                                  : 'switch grid '
                              }
                              onClick={() => onClickViewstatus(0)}
                            >
                              <svg>
                                <use href="/ui/images/sprites/brenderup.svg#grid-view"></use>
                              </svg>
                            </a>
                            <a
                              className={
                                viewStatus == 1
                                  ? 'switch list active'
                                  : 'switch list '
                              }
                              onClick={() => onClickViewstatus(1)}
                            >
                              <svg>
                                <use href="/ui/images/sprites/brenderup.svg#list-view"></use>
                              </svg>
                            </a>
                          </div>

                          <div className="chassi-search--sticky">
                            {hasSpareParts(chassiSearchList) && 
                            <a href="#Spareparts1">
                              {translate('chassisearch.viewspareparts')}
                            </a>}
                            
                            {hasAccessories(chassiSearchList) &&
                            <a href="#Accessories">
                              {translate('chassisearch.viewaccessories')}
                            </a>
                            }
                            
                            <a href="#">{translate('chassisearch.scrollup')}</a>
                          </div>
                        </Fragment>
                      )}
                      {IsValidData() &&
                        chassiSearchList[selectedChassiIndex].Categories &&
                        chassiSearchList[selectedChassiIndex].Categories
                          .length > 0 &&
                        chassiSearchList[selectedChassiIndex].Categories.map(
                          (category, index) => (
                            <ChassiSearchItemsContainer key={'chassi-ct-div' + index} category={category} index={index} isListView={false}/>
                          )
                        )}
                      {IsValidData() &&
                        chassiSearchList[selectedChassiIndex].NonPIM && (
                          <div>
                            {chassiSearchList[selectedChassiIndex].NonPIM
                              .NonPIMItems.length > 0 && (
                              <Fragment>
                                <div className="small-12 text--center">
                                  <h3 className="category-name">
                                    {
                                      chassiSearchList[selectedChassiIndex]
                                        .NonPIM.CategoryName
                                    }
                                  </h3>
                                </div>
                                <GridViewNonPimItemContainer
                                  nonPIMItems={
                                    chassiSearchList[selectedChassiIndex]
                                      .NonPIM['NonPIMItems']
                                  }
                                ></GridViewNonPimItemContainer>
                              </Fragment>
                            )}
                          </div>
                        )}
                    </Fragment>
                  ) : (
                    <Fragment>
                      {IsValidData() && (
                        <Fragment>
                          <div className="chassi-search--switch-view">
                            <a
                              className={
                                viewStatus == 0
                                  ? 'switch grid active'
                                  : 'switch grid '
                              }
                              onClick={() => onClickViewstatus(0)}
                            >
                              <svg>
                                <use href="/ui/images/sprites/brenderup.svg#grid-view"></use>
                              </svg>
                            </a>
                            <a
                              className={
                                viewStatus == 1
                                  ? 'switch list active'
                                  : 'switch list '
                              }
                              onClick={() => onClickViewstatus(1)}
                            >
                              <svg>
                                <use href="/ui/images/sprites/brenderup.svg#list-view"></use>
                              </svg>
                            </a>
                          </div>

                          <div className="chassi-search--sticky">
                          {hasSpareParts(chassiSearchList) && 
                            <a href="#Spareparts1">
                              {translate('chassisearch.viewspareparts')}
                            </a>
                          }
                          {hasAccessories(chassiSearchList) &&
                            <a href="#Accessories">
                              {translate('chassisearch.viewaccessories')}
                            </a>
                          }
                            <a href="#">{translate('chassisearch.scrollup')}</a>
                          </div>
                        </Fragment>
                      )}
                      {IsValidData() &&
                        chassiSearchList[selectedChassiIndex].Categories &&
                        chassiSearchList[selectedChassiIndex].Categories
                          .length > 0 &&
                        chassiSearchList[selectedChassiIndex].Categories.map(
                          (category, index) => (
                            <Fragment key={'chassi-lv-div' + index}>
                              <ChassiSearchItemsContainer  category={category} index={index} isListView={true} />
                            </Fragment>
                          )
                        )}
                      {IsValidData() &&
                        chassiSearchList[selectedChassiIndex].NonPIM && (
                          <div>
                            {chassiSearchList[selectedChassiIndex].NonPIM
                              .NonPIMItems.length > 0 && (
                              <Fragment>
                                <div className="small-12 text--center">
                                  <h3 className="category-name">
                                    {
                                      chassiSearchList[selectedChassiIndex]
                                        .NonPIM.CategoryName
                                    }
                                  </h3>
                                </div>
                                <ListViewNonPimItemContainer
                                  nonPIMItems={
                                    chassiSearchList[selectedChassiIndex]
                                      .NonPIM['NonPIMItems']
                                  }
                                ></ListViewNonPimItemContainer>
                              </Fragment>
                            )}
                          </div>
                        )}
                    </Fragment>
                  )}
                </div>
              )}
            </Fragment>
          )}

          {isDataerror && (
            <div className="chassi-search--error">
              <svg>
                <use href="/ui/images/sprites/brenderup.svg#error"></use>
              </svg>
              {translate('chassisearch.errormessage')}
            </div>
          )}
        </div>
      </div>
    </Fragment>
  );
};

export default ChassiSearchContainer;
